import script from "./RequestForm-Evrt.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestForm-Evrt.vue?vue&type=script&setup=true&lang=js"

import "./RequestForm-Evrt.vue?vue&type=style&index=0&id=78fad24b&lang=css"

const __exports__ = script;

export default __exports__